import '@/scripts/_foundation'
import '@/scripts/_fontawesome'

global.jQuery = require('jquery')
let $ = global.jQuery
window.$ = $

$(document).ready(function () {
  // $(window).scroll(function () {
  //   $('.sticky').each(function () {
  //     console.log(window.scrollTop() + ':' + $(this).offset().top)
  //
  //     if ($(window).scrollTop() >= $(this).offset().top) {
  //       $(this).css('position', 'fixed')
  //     } else {
  //       $(this).css('position', 'relative')
  //     }
  //   })
  // })
})



// WEBPACK FOOTER //
// ./src/scripts/app.js